import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Organization APIs
export const organizationAPI = {
  create: (data) => api.post('/organizations', data),
  get: () => api.get('/organizations/me'),
  update: (data) => api.put('/organizations/me', data),
  getStats: () => api.get('/organizations/stats'),
  linkBankAccount: (data) => api.post('/organizations/bank-account', data),
  getBankAccount: () => api.get('/organizations/bank-account')
};

// Department APIs
export const departmentAPI = {
  create: (data) => api.post('/departments', data),
  list: () => api.get('/departments'),
  get: (id) => api.get(`/departments/${id}`),
  update: (id, data) => api.put(`/departments/${id}`, data),
  delete: (id) => api.delete(`/departments/${id}`),
  allocateFunds: (id, amount) => api.post(`/departments/${id}/allocate-funds`, { amount }),
  getStats: (id) => api.get(`/departments/${id}/stats`)
};

// Rule APIs
export const ruleAPI = {
  create: (departmentId, data) => api.post(`/rules/${departmentId}`, data),
  list: (departmentId) => api.get('/rules', { params: { department_id: departmentId } }),
  listAll: () => api.get('/rules'),
  get: (id) => api.get(`/rules/${id}`),
  update: (id, data) => api.put(`/rules/${id}`, data),
  delete: (id) => api.delete(`/rules/${id}`)
};

// Transaction APIs
export const transactionAPI = {
  create: (data) => api.post('/transactions', data),
  list: (params) => api.get('/transactions', { params }),
  getPending: () => api.get('/transactions/pending'),
  get: (id) => api.get(`/transactions/${id}`),
  approve: (id) => api.post(`/transactions/${id}/action`, { action: 'approve' }),
  reject: (id, reason) => api.post(`/transactions/${id}/action`, { action: 'reject', reason }),
  requestInfo: (id, reason) => api.post(`/transactions/${id}/action`, { action: 'request_info', reason }),
  respondInfo: (id, response) => api.post(`/transactions/${id}/respond-info`, { info_response: response })
};

// Beneficiary APIs
export const beneficiaryAPI = {
  create: (data) => api.post('/beneficiaries', data),
  list: (departmentId) => api.get('/beneficiaries', { params: { department_id: departmentId } }),
  get: (id) => api.get(`/beneficiaries/${id}`),
  update: (id, data) => api.put(`/beneficiaries/${id}`, data),
  delete: (id) => api.delete(`/beneficiaries/${id}`),
  toggleBlacklist: (id) => api.post(`/beneficiaries/${id}/blacklist`)
};

// Notification APIs
export const notificationAPI = {
  list: (unreadOnly = false) => api.get('/notifications', { params: { unread_only: unreadOnly } }),
  getUnreadCount: () => api.get('/notifications/unread-count'),
  markAsRead: (id) => api.post(`/notifications/${id}/read`),
  markAllAsRead: () => api.post('/notifications/read-all'),
  delete: (id) => api.delete(`/notifications/${id}`)
};

// Report APIs
export const reportAPI = {
  getSpendingByDepartment: (startDate, endDate) => 
    api.get('/reports/spending-by-department', { params: { start_date: startDate, end_date: endDate } }),
  getSpendingByVendor: (departmentId, limit) =>
    api.get('/reports/spending-by-vendor', { params: { department_id: departmentId, limit } }),
  getSpendingTrends: (period, departmentId, days) =>
    api.get('/reports/spending-trends', { params: { period, department_id: departmentId, days } }),
  getRuleCompliance: () => api.get('/reports/rule-compliance'),
  getSummary: () => api.get('/reports/summary')
};

// User APIs
export const userAPI = {
  list: () => api.get('/users'),
  get: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users/create', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`)
};

export default api;
